import {IntermediatePart} from "../../intermediatePart";
import {METADATA} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class BathTubBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_body";
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub.bathtub";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["BathType"]) {
      dbFeature.metaData["BathType"] = [METADATA.BathtubWithoutEnclosures]; // remove enclosure top and bottom
    }
    return super.load(dbFeature);
  }

  disableReplacementTub() {
    const bathParent = this.getParent();
    const comboParent = bathParent.layout.parts[ShowerTubCombo.id];
    if (comboParent.freeStandingTubActive()) {
      comboParent.replacementTub.disabled = true;
    }
  }

  disabledClick() {
    const bathParent = this.getParent();
    if (!this.disabled) {
      this.disableReplacementTub();
    }
    ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
      if (bathParent[relName]) {
        bathParent[relName].disabled = this.disabled;
      }
    })
  }
}
